import { Component } from '@angular/core';
import { PropertiesService } from './properties.service';
import { TemplatesService } from './templates.service';
import { LayoutService } from './layout.service';
import { Router, RouterEvent } from '@angular/router';
declare var feather:any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'cloak-and-dagger';

  constructor(private layoutService: LayoutService, private properties: PropertiesService, private template: TemplatesService, private router: Router) {
    this.properties.currentMessage.subscribe(message => {
      console.log('got a message', message);
      feather.replace();
    });

    this.router.events.subscribe((routerEvent: RouterEvent) => {
      // console.log(routerEvent);
      feather.replace();
    });
  }

  ngOnInit() {
    this.template.getTemplates().then(reply => console.log('Loaded templates'));
  }
}
